type AnyArgs = any[];
type FnArg = (...args: AnyArgs) => any;
type Timeout = ReturnType<typeof setTimeout>;

export const debounce = (fn: FnArg, timeoutMs: number): FnArg => {
  let timeoutId: Timeout;
  return (...args: AnyArgs) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      fn(...args);
    }, timeoutMs);
  };
};
